import HudButton from "app/ui/HudButton";
import IconZoomIn from "app/icons/IconZoomIn";
import IconZoomOut from "app/icons/IconZoomOut";
import cn from "app/util/classnames";

const ICON_SIZE = 24;

interface ZoomButtonProps {
  isZoomed: boolean;
  onClick: () => void;
}

export default function ZoomButton(props: ZoomButtonProps) {
  return (
    <div className="flex flex-col items-center p-1 pr-1.5">
      <HudButton onClick={props.onClick}>
        {props.isZoomed ? (
          <IconZoomOut width={ICON_SIZE} height={ICON_SIZE} />
        ) : (
          <IconZoomIn width={ICON_SIZE} height={ICON_SIZE} />
        )}
      </HudButton>
      <p // Button label
        className={cn("uppercase text-xs")}
      >
        {props.isZoomed ? "Zoom-" : "Zoom+"}
      </p>
    </div>
  );
}
